import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useLocation  } from "react-router-dom";
import { useExtSubmission } from "api";

export let menuIdList = {}

const Navdata = () => {
  const history = useNavigate(); //react router 객체 선언
  const location = useLocation();
  const extSubmission = useExtSubmission(); //submission 함수 선언

  //state data
  const [isOpenStates, setIsOpenStates] = useState({}); // 메뉴의 열림 상태를 제어할 state 선언
  const [iscurrentState, setIscurrentState] = useState(""); // 현재 열려있는 메뉴를 가지는 state 선언

  const [menuDatas, setMenuDatas] = useState([]); //submission으로 부터 받아온 listMenuAll를 담을 state 선언
  const [list, setList] = useState([]); //listMenuAll를 가공하여 화면 사이드 네비게이션에 넣어줄 menus 데이터 state 선언

  //사이드 메뉴 네비게이션 css Bootstrap class 핸들링
  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {

      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];

      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  //submission으로부터 가져온 menu의 데이터로 state initialize 하는 함수
  const initMenu = useCallback(async () => {
    await extSubmission("/cpm/com/menu/subList.do", {}, (e, data) => {

      if (e) console.log(e);
      if(data.result?.listMenuAll?.length === 0   ) return false ;
      
      const { listMenuAll } = data.result; //response 받아오기
      setMenuDatas((prev) => [...listMenuAll]); //response를 state에 할당

      // response에서 사용하는 scrnPgmId만 뽑아서 menuId로 key:value 맵핑 (export하여 realGrid에서 사용)
      menuIdList = listMenuAll.reduce((acc, cur) => (cur.scrnPgmId ? {...acc, [cur.scrnPgmId]: cur.menuId} : acc), {}) 

      // response의 menuId: false로 isOpenState 초기화
      listMenuAll.forEach((el) =>
        setIsOpenStates((prev) => ({ ...prev, [`${el.menuId}`]: el.menuId === iscurrentState  }))
      );
      return true;
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Bootstrap에서 제공하는 LayoutMenuData 컴포넌트 데이터 형식으로 메뉴리스트 데이터를 가공하는 함수
  const setMenuList = () => {
    
    /*
      response로부터 받아온 menuDatas 배열을 순회하며 각 원소를 가공하여 새로운 배열로 리턴한다.(reduce 함수)
      el은 menuData를 순차적으로 순회하며 참조하는 각 원소
      acc는 리턴할 새로운 배열 
      el을 가공하여 만들어진 새로운 원소를 acc에 하나씩 담아 순회가 완료되면 acc 리턴. 
      reduce 함수의 2번째 인자로 acc 초기값 선언(빈 배열)
    */
    const menus = menuDatas.reduce(
        (acc, el) => {
          const { menuNm, iconFileNm, menuLevel, menuId } = el; //각 메뉴의 object를 비구조화 할당
          const menu = {}; //매 순회마다 가공된 el로 acc로 들어갈 object 선언

          //menu레벨이 2뎁스인 경우 menu로 담는다. (현재 대쉬보드, 광고구매, 보고)
          if (menuLevel === "2") {
            // menuDatas의 각 원소를 Bootstrap 메뉴 데이터 형식에 맞게 가공
            menu[`id`] = menuId;
            menu[`label`] = menuNm;
            menu[`icon`] = iconFileNm;
            menu[`link`] = "/#";
            menu.stateVariables = isOpenStates[`${menuId}`];
            menu.click = (e) => { //메뉴의 클릭이벤트로 각 menuId에 해당하는 open 상태의 boolean 값을 업데이트한다.
              e.preventDefault();
              setIsOpenStates({
                ...isOpenStates,
                [`${menuId}`]: !isOpenStates[`${menuId}`],
              });
              setIscurrentState(menuId);
              updateIconSidebar(e);
            };

            //상위 reduce의 원소가 가지는 menuId를 upMenuId로 가지는 메뉴찾기(하위 메뉴)
            menu[`subItems`] = menuDatas.reduce((acc2, data) => {
              if (data.upMenuId === menuId) {
                //하위 메뉴의 데이터를 현재 메뉴의 subItem으로 넣어주기
                const subItem = {
                  id: data.menuId,
                  label: data.menuNm,
                  link: `/${data.scrnPgmId}`,
                  parentId: data.upMenuId,
                };
                acc2.push(subItem);
              }
              return acc2;
            }, []);

            acc.push(menu);
          }
          //acc가 순회할 때마다 menuLevel이 2인 메뉴를 세팅하여 리턴한다.
          return acc;
        },
        [{ label: "", isHeader: true }]
      )

      //소재관리는 웹스퀘어 팝업을 띄워야 하는 이슈로 하드코딩
      menus.push({
        id: "30474",
        label: "소재 관리",
        icon: "ri-file-edit-line",
        link:"#" ,
        click: () => {
          var mtrlMenuId = {
              "SAA01" : 30474
            , "SAA03" : 30608
            , "SAA05" : 30912
          }  ;

          var _compTypeCd =  ( sessionStorage.getItem("compTypeCd")  ?? "")   ;
          if(_compTypeCd !== "" &&  ( mtrlMenuId[_compTypeCd] ?? "") !== "" ){
            var url ="/websquare/websquare.jsp?w2xPath=/modules/layout.do&menuId=" + mtrlMenuId[_compTypeCd]  ;
            window.open(url,'_blank','');
          }
        },
      });
    setList(menus)
  };
  useEffect(() => {
    initMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const menuStats = menuDatas.map((menu) => menu.menuId).map((menuId) => isOpenStates[menuId]).join("");

  useEffect(() => {
    //Bootstrap 클래스 제어
    document.body.classList.remove("twocolumn-panel");

    try{
      //메뉴에 따라 페이지가 변환될때마다 각 메뉴의 isOpenState를 핸들링
      menuDatas.forEach((el) => {
        if (  iscurrentState === el.menuId  ) {
          setIsOpenStates( ( prev ) => ( { ...prev , [ `${el.menuId}` ] : true } ) );
        }else if (  el.scrnPgmId === location.pathname.replaceAll("/", "") ) {
          setIsOpenStates( ( prev ) => ( { ...prev , [ `${el.upMenuId}` ] : true , [ `${el.menuId}` ] : false } ) );
          if(iscurrentState === ""){
            setIscurrentState((el.menuLevel ==="2")?el.menuId: el.upMenuId);
          }
        }else{
          setIsOpenStates((prev) => ({ ...prev, [`${el.menuId}`]: false }));
        }
      });
    }catch (e) {
    }
    //submission의 결과로 menuData가 존재할때 메뉴리스트를 set한다.
    if (menuDatas?.length > 0) {
      setMenuList();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    history,
    iscurrentState,
    menuDatas.length ,
    menuStats
  ]);
  return list && <React.Fragment>{list}</React.Fragment>;
};
export default Navdata;
